import { Device } from '@twilio/voice-sdk';

export const twilioDevice = async (data: { token: string; options?: Device.Options }) => {
  const device = new Device(data.token, data.options);

  return device;
};
